import { render, staticRenderFns } from "./ViewNoThankYouMessageAction.vue?vue&type=template&id=197bdc28&"
import script from "./ViewNoThankYouMessageAction.vue?vue&type=script&lang=js&"
export * from "./ViewNoThankYouMessageAction.vue?vue&type=script&lang=js&"
import style0 from "./ViewNoThankYouMessageAction.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports